import React, { useRef, useEffect } from 'react';
import Marquee from 'vanilla-marquee/dist/vanilla-marquee';
import { OnLive } from 'components/on-live';

export default function HighlightsBar({ model }) {
    if (!model) return null;

    const bemCss = model.mode ? `highlights-bar--${model.mode}` : '';
    const tickerRef = useRef(null);
    const listRef = useRef(null);
    const marqueeRef = useRef(null);
    const originalHTMLRef = useRef('');

    useEffect(() => {
        const wrapper = tickerRef.current;
        const list = listRef.current;
        if (!wrapper || !list) return;

        if (!originalHTMLRef.current) {
            originalHTMLRef.current = wrapper.innerHTML;
        }

        const stopTickerCompletely = () => {
            if (marqueeRef.current) {
                marqueeRef.current.destroy();
                marqueeRef.current = null;
            }
            if (wrapper && originalHTMLRef.current) {
                wrapper.innerHTML = originalHTMLRef.current;
                listRef.current = wrapper.querySelector('#ticker-list');
            }
        };

        const update = () => {
            const fits = list.scrollWidth <= wrapper.clientWidth;
            if (!fits && !marqueeRef.current) {
            // start marquee
                marqueeRef.current = new Marquee(list, {
                    speed: 30,
                    direction: 'left',
                    duplicated: true,
                    delayBeforeStart: 1500,
                    pauseOnHover: true,
                    startVisible: true,
                    recalcResize: true,
                });
            } else if (fits && marqueeRef.current) {
                stopTickerCompletely();
            }
        };
        update();
        window.addEventListener('resize', update);
        // eslint-disable-next-line arrow-body-style
        return () => {
            window.removeEventListener('resize', update);
            if (marqueeRef.current) {
                marqueeRef.current.destroy();
                stopTickerCompletely();
                marqueeRef.current = null;
            }
        };
    }, [model.items]);

    return (
        <div className={`highlights-bar ${bemCss}`}>
            {model.isLive && <div className="highlights-bar__heading">
                <div className="highlights-bar__live"><OnLive /></div>
            </div>}
            <div className="highlights-bar__wrapper">
                <div className="highlights-bar__ticker" ref={tickerRef}>
                    <div className="highlights-bar__list" id="ticker-list" ref={listRef}>
                        {
                            Array.isArray(model.items) &&
                            model.items.map((highlight) => (
                                <div
                                    className="highlights-bar__li"
                                    key={highlight.id}
                                    dangerouslySetInnerHTML={{ __html: highlight.body }} />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
